import { UploadType } from '@/components/MassUploadTable/MassUploadTable.types';
import { IFileMetadata } from 'types';

export interface IUploadRecord {
  file?: File;
  hasPreviousVersion?: boolean;
  metadata?: IFileMetadata;
  rawMetadata: Record<string, string>;
  uploadType: UploadType;
  renditionFile?: IRenditionFile;
}

export interface IRenditionFile {
  file?: File;
  /**
   * Only the Filepath is needed for the rendition file.
   */
  metadata?: IFileMetadata;
}

export interface IFileUploadStatuses {
  [documentId: string]: FileUploadStatus;
}

export enum FileUploadStatus {
  UPLOADING = 'uploading',
  UPLOADED = 'uploaded',
}

export interface IMassUploadFile {
  file: File;
  path: string;
}
